import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import ViewIcon from "@material-ui/icons/Visibility";
import InfoAuto from "../../vehicles/InfoAuto/InfoAuto";
import { userHasRole } from "../../auth/UserFunctions";

const InfoAutoDialog = ({ version, model }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Typography
        variant="button"
        className="mt-4"
        onClick={() => setOpen(!open)}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          display: "inline-block"
        }}
      >
        Ver Ficha InfoAuto{" "}
      </Typography>
      <Dialog
        PaperProps={{
          style: {
            width: "900px",
            maxWidth: "900px"
          }
        }}
        open={open}
        fullWidth
        aria-labelledby="responsive-dialog-title"
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          {"Ficha InfoAuto"}
        </DialogTitle>
        <DialogContent style={{ width: "900px" }}>
          <InfoAuto variation={model} version={version} />
        </DialogContent>
      </Dialog>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const BasicData = ({
  onChange,
  onValidatePlate,
  disabled,
  error,
  title,
  basic_data,
  brands,
  models,
  versions,
  fleet_types,
  colors,
  owner_types,
  vehicle_states,
  condition_types,
  vtv_provinces,
  vtv_cities,
  plate_provinces,
  plate_cities,
  clients,
  investor_providers,
  plate_exists,
  version,
  variation,
  //sap_projects,
  ...props
}) => {
  var data = {};

  const handleChange = event => {
    onChange(event, "basic_data");
  };

  const validatePlate = () => {
    onValidatePlate();
  };

  const getVtvCities = province_id => {
    var cities_filtered = [];
    vtv_cities.map((val, idx) => {
      if (parseInt(val.province_id) === parseInt(province_id)) {
        cities_filtered.push(val);
      }
    });
    return cities_filtered;
  };

  const getData = version_id => {
    const data = {};
    versions.map((val, idx) => {
      if (parseInt(val.id) === parseInt(version_id)) {
        data.renting_description = val.renting_description;
        data.type = val.vehicle_type
          ? val.vehicle_type.hansa_code + " " + val.vehicle_type.name
          : "";
        data.name = val.name;
        data.model = "";
        var variation = models.filter(
          model => parseInt(model.id) === parseInt(val.variation_id)
        );
        if (variation[0]) {
          data.model = variation[0].dnrpa_description;
        }
      }
    });
    return data;
  };

  const classes = useStyles();
  if (basic_data.version_id !== "") {
    data = getData(basic_data.version_id);
  }
  var vtv_cities_filtered = vtv_cities;
  var plate_cities_filtered = plate_cities;
  /*if(basic_data.vtv_province_id !== ''){
    var vtv_cities_filtered = getVtvCities(basic_data.vtv_province_id)
  }*/

  /*  if(basic_data.plate_province_id !== ''){
    var plate_cities_filtered = getVtvCities(basic_data.plate_province_id)
  }
*/
  var today = new Date();
  var state = vehicle_states.filter(
    s => parseInt(s.id) === parseInt(basic_data.vehicle_state_id)
  );
  var plate_disabled = disabled || basic_data.id !== "";
  var is_precreated = false;
  if (state[0]) {
    plate_disabled = state[0].hansa_code === "PREALTA" ? false : true;
    is_precreated = state[0].hansa_code === "PREALTA" ? true : false;
  }

  let state_disabled =
    disabled ||
    (parseInt(basic_data.is_fleet_owner) == 1 &&
      basic_data.id > 0 &&
      state &&
      state[0] &&
      state[0].hansa_code !== "ALTA");

  if (
    userHasRole("vehicle-state.admin") &&
    parseInt(basic_data.is_fleet_owner) == 1
  )
    state_disabled = false;

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <TextField
        id="plate"
        name="plate"
        label="Patente"
        disabled={plate_disabled}
        error={
          error !== "" && (basic_data.plate === "" || plate_exists)
            ? plate_exists
              ? "La patente ya existe"
              : "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && (basic_data.plate === "" || plate_exists)
            ? plate_exists
              ? "La patente ya existe"
              : "Debe completar este campo"
            : ""
        }
        type="text"
        required
        placeholder="Ingrese la patente"
        onChange={handleChange}
        onBlur={validatePlate}
        value={basic_data.plate}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="code"
        name="code"
        label="Cod. Interno"
        disabled={disabled}
        type="text"
        placeholder="Ingrese el codigo interno"
        onChange={handleChange}
        value={basic_data.code}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />
      {brands.length > 0 && (
        <FormControl
          className="mt-3 mr-2"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          name="brand_id"
        >
          <InputLabel
            htmlFor="grouped-native-select"
            autoWidth="true"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
          >
            Marca
          </InputLabel>
          <Select
            native
            name="brand_id"
            inputProps={{
              name: "brand_id",
              className: "brand_id"
            }}
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            disabled={disabled}
            onChange={handleChange}
            required
            error={
              error !== "" && basic_data.brand_id === ""
                ? "Debe completar este campo"
                : false
            }
            value={basic_data.brand_id}
            input={<Input id="grouped-native-select" name="brand_id" />}
          >
            <option value="" />
            {brands.map(brand => (
              <option id={brand.id} value={brand.id}>
                {brand.name}
              </option>
            ))}
          </Select>
          {error !== "" && basic_data.brand_id === "" && (
            <FormHelperText style={{ color: "red" }}>
              Debe completar este campo
            </FormHelperText>
          )}
        </FormControl>
      )}

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="model_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Modelo
        </InputLabel>
        <Select
          native
          name="model_id"
          inputProps={{
            name: "model_id",
            className: "model_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && basic_data.model_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.model_id}
          input={<Input id="grouped-native-select" name="model_id" />}
        >
          <option value="" />
          {models.map(model => (
            <option id={model.id} value={model.id}>
              {model.dnrpa_description}
            </option>
          ))}
        </Select>
        {error !== "" && basic_data.model_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="version_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Versión
        </InputLabel>
        <Select
          native
          name="version_id"
          inputProps={{
            name: "version_id",
            className: "version_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && basic_data.version_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.version_id || ""}
          input={<Input id="grouped-native-select" name="version_id" />}
        >
          <option value="" />
          {versions.map(version => {
            const year = basic_data.year;

            const isDisabled =
              version.id === 1 ||
              !version.infoauto_codia ||
              (year && year < version.infoauto_start_year) ||
              (year && year > version.infoauto_end_year);

            return (
              <option
                key={version.id}
                value={version.id}
                disabled={isDisabled}
              >
                {version.name}
                {version.infoauto_codia
                  ? ` - ${version.infoauto_codia} (${version.infoauto_start_year ? version.infoauto_start_year : ""} - ${version.infoauto_end_year ? version.infoauto_end_year : ""})`
                  : ""}
              </option>
            );
          })}
        </Select>
        {/*error !== "" && !basic_data.infoauto_codia && (
              (basic_data.year && basic_data.year < basic_data.version.infoauto_start_year) ||
              (basic_data.year && basic_data.year > basic_data.version.infoauto_end_year)          
        ) && (
          <FormHelperText style={{ color: "red" }}>
            Debe seleccionar una versión válida
          </FormHelperText>
        )*/}
      </FormControl>
      {basic_data.id ? (
        <TextField
          id="description"
          name="description"
          label="Descripción hansa"
          disabled={true}
          type="text"
          value={basic_data.description}
          error={
            error !== "" &&
            !basic_data.description &&
            basic_data.description !== "" &&
            !basic_data.description.includes(data.model) &&
            !is_precreated
              ? "El modelo está mal asignado con Hansa."
              : false
          }
          helperText={
            error !== "" &&
            !basic_data.description &&
            basic_data.description !== "" &&
            !basic_data.description.includes(data.model) &&
            !is_precreated
              ? "El modelo está mal asignado con Hansa."
              : ""
          }
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { fontSize: "0.75rem" } }}
        />
      ) : (
        ""
      )}

      {basic_data.version_id !== "" ? (
        <React.Fragment>
          <TextField
            id="vehicle_type"
            name="vehicle_type"
            label="Tipo de vehiculo"
            disabled={true}
            type="text"
            onChange={handleChange}
            value={data.type}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
          <TextField
            id="renting_description"
            name="renting_description"
            label="Renting"
            disabled={true}
            type="text"
            onChange={handleChange}
            value={data.renting_description}
            error={
              error !== "" && data.renting_description === ""
                ? "Debe completar este dato primero en el modelo"
                : false
            }
            helperText={
              error !== "" && data.renting_description === ""
                ? "Debe completar este dato primero en el modelo"
                : ""
            }
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
        </React.Fragment>
      ) : (
        ""
      )}

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="is_fleet_owner"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Tipo de flota
        </InputLabel>
        <Select
          native
          name="is_fleet_owner"
          inputProps={{
            name: "is_fleet_owner",
            className: "is_fleet_owner"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && basic_data.is_fleet_owner === ""
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.is_fleet_owner}
          input={<Input id="grouped-native-select" name="is_fleet_owner" />}
        >
          <option value="" />
          {fleet_types.map(fleet_type => (
            <option id={fleet_type.id} value={fleet_type.id}>
              {fleet_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && basic_data.is_fleet_owner === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <TextField
        id="year"
        name="year"
        label="Año del vehículo"
        disabled={disabled}
        error={
          error !== "" && basic_data.year === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.year === ""
            ? "Debe completar este valor"
            : ""
        }
        type="number"
        required
        placeholder="Ingrese el año del vehículo"
        onChange={handleChange}
        value={basic_data.year}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        InputProps={{
          style: { minWidth: 200, fontSize: "0.75rem" },
          inputProps: { min: 0 }
        }}
      />

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="plate_province_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Provincia patentamiento
        </InputLabel>
        <Select
          native
          name="plate_province_id"
          inputProps={{
            name: "plate_province_id",
            className: "plate_province_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          onChange={handleChange}
          disabled={disabled}
          error={
            error !== "" &&
            (basic_data.plate_province_id === "" ||
              basic_data.plate_province_id == null)
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.plate_province_id}
          input={<Input id="grouped-native-select" name="plate_province_id" />}
        >
          <option value="" />
          {plate_provinces.map(province => (
            <option id={province.id} value={province.id}>
              {province.name}
            </option>
          ))}
        </Select>
        {error !== "" &&
          (basic_data.plate_province_id === "" ||
            basic_data.plate_province_id == null) && (
            <FormHelperText style={{ color: "red" }}>
              Debe completar este campo
            </FormHelperText>
          )}
      </FormControl>

      {basic_data.plate_province_id !== "" ? (
        <FormControl
          className="mt-3 mr-2"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          name="plate_city_id"
        >
          <InputLabel
            htmlFor="grouped-native-select"
            autoWidth="true"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
          >
            Localidad patentamiento
          </InputLabel>
          <Select
            native
            name="plate_city_id"
            inputProps={{
              name: "plate_city_id",
              className: "plate_city_id"
            }}
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            disabled={disabled}
            onChange={handleChange}
            error={
              error !== "" &&
              (basic_data.plate_city_id === "" ||
                basic_data.plate_city_id == null)
                ? "Debe completar este campo"
                : false
            }
            value={basic_data.plate_city_id}
            input={<Input id="grouped-native-select" name="plate_city_id" />}
          >
            <option value="" />
            {plate_cities_filtered.map(city => (
              <option id={city.id} value={city.id}>
                {city.name}
              </option>
            ))}
          </Select>
          {error !== "" &&
            (basic_data.plate_city_id === "" ||
              basic_data.plate_city_id == null) && (
              <FormHelperText style={{ color: "red" }}>
                Debe completar este campo
              </FormHelperText>
            )}
        </FormControl>
      ) : (
        " "
      )}

      <TextField
        id="plate_date"
        name="plate_date"
        label="Fecha de patentamiento"
        disabled={disabled}
        required
        error={
          error !== "" &&
          (basic_data.plate_date === "" || basic_data.plate_date == null)
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" &&
          (basic_data.plate_date === "" || basic_data.plate_date == null)
            ? "Debe completar este valor"
            : ""
        }
        type="date"
        placeholder="Ingrese la fecha de patentamiento"
        onChange={handleChange}
        value={basic_data.plate_date || ""}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="color"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Color
        </InputLabel>
        <Select
          native
          name="color"
          inputProps={{
            name: "color",
            className: "color"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          error={
            error !== "" &&
            parseInt(basic_data.is_fleet_owner) === 1 &&
            (basic_data.color === "" || basic_data.color == null)
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.color}
          input={<Input id="grouped-native-select" name="color" />}
        >
          <option value="" />
          {colors.map(color => (
            <option id={color.id} value={color.id}>
              {color.name}
            </option>
          ))}
        </Select>
        {error !== "" &&
          parseInt(basic_data.is_fleet_owner) === 1 &&
          (basic_data.color === "" || basic_data.color == null) && (
            <FormHelperText style={{ color: "red" }}>
              Debe completar este campo
            </FormHelperText>
          )}
      </FormControl>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="is_owner"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Es titular?
        </InputLabel>
        <Select
          native
          name="is_owner"
          inputProps={{
            name: "is_owner",
            className: "is_owner"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          error={
            error !== "" && basic_data.is_owner === ""
              ? "Debe completar este campo"
              : false
          }
          value={basic_data.is_owner}
          input={<Input id="grouped-native-select" name="is_owner" />}
        >
          <option value="" />
          {owner_types.map(owner_type => (
            <option id={owner_type.id} value={owner_type.id}>
              {owner_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && basic_data.is_owner === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      {basic_data.is_owner === "Empresa" && clients.length > 0 ? (
        <FormControl
          className="mt-3 mr-2"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          name="owner_contact_id"
        >
          <InputLabel
            htmlFor="grouped-native-select"
            autoWidth="true"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
          >
            Empresa Titular
          </InputLabel>
          <Select
            native
            name="owner_contact_id"
            inputProps={{
              name: "owner_contact_id",
              className: "owner_contact_id"
            }}
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            disabled={disabled}
            onChange={handleChange}
            error={
              error !== "" && basic_data.owner_contact_id === ""
                ? "Debe completar este campo"
                : false
            }
            value={basic_data.owner_contact_id || ""}
            input={<Input id="grouped-native-select" name="is_owner" />}
          >
            <option value="" />
            {clients.map(client => (
              <option id={client.contact_id} value={client.contact_id}>
                {client.business_name}
              </option>
            ))}
          </Select>
          {error !== "" && basic_data.owner_contact_id === "" && (
            <FormHelperText style={{ color: "red" }}>
              Debe completar este campo
            </FormHelperText>
          )}
        </FormControl>
      ) : (
        ""
      )}
      {basic_data.is_owner === "Leasing" ? (
        <React.Fragment>
          {/*            <TextField
              id="leasing_owner"
              name="leasing_owner"
              label="Empresa Leasing"
              disabled={disabled}
              type="text"
              placeholder="Ingrese la empresa de leasing"
              onChange={handleChange}
              value={basic_data.leasing_owner}
              margin="normal"
              className="mr-2 "
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{style:{minWidth: 200, fontSize: '0.75rem'}}} 
            />
*/}
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="leasing_contact_id"
          >
            <InputLabel
              htmlFor="grouped-native-select"
              autoWidth="true"
              style={{ minWidth: 200, fontSize: "0.75rem" }}
            >
              Seleccione la empresa
            </InputLabel>
            <Select
              native
              name="leasing_contact_id"
              inputProps={{
                name: "leasing_contact_id",
                className: "leasing_contact_id"
              }}
              style={{ minWidth: 200, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              error={
                error !== "" && basic_data.leasing_contact_id === ""
                  ? "Debe completar este campo"
                  : false
              }
              value={basic_data.leasing_contact_id}
              input={
                <Input id="grouped-native-select" name="leasing_contact_id" />
              }
            >
              <option value="" />
              {investor_providers.map(investor_provider => (
                <option
                  id={investor_provider.contact_id}
                  value={investor_provider.contact_id}
                >
                  {investor_provider.contact.hansa_code} -{" "}
                  {investor_provider.business_name}
                </option>
              ))}
            </Select>
            {error !== "" && basic_data.leasing_contact_id === "" && (
              <FormHelperText style={{ color: "red" }}>
                Debe completar este campo
              </FormHelperText>
            )}
          </FormControl>
          <TextField
            id="leasing_duedate"
            name="leasing_duedate"
            label="Fecha Vto. Leasing"
            disabled={disabled}
            type="date"
            placeholder="Ingrese la fecha fin de leasing"
            onChange={handleChange}
            value={basic_data.leasing_duedate}
            margin="normal"
            className="mr-2 "
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
          />
        </React.Fragment>
      ) : (
        ""
      )}

      {basic_data.is_owner === "Prenda" ? (
        <React.Fragment>
          <FormControl
            className="mt-3 mr-2"
            style={{ minWidth: 150, fontSize: "0.75rem" }}
            name="pledge_contact_id"
          >
            <InputLabel
              htmlFor="grouped-native-select"
              autoWidth="true"
              style={{ minWidth: 200, fontSize: "0.75rem" }}
            >
              Seleccione la empresa
            </InputLabel>
            <Select
              native
              name="pledge_contact_id"
              inputProps={{
                name: "pledge_contact_id",
                className: "pledge_contact_id"
              }}
              style={{ minWidth: 200, fontSize: "0.75rem" }}
              disabled={disabled}
              onChange={handleChange}
              error={
                error !== "" && basic_data.pledge_contact_id === ""
                  ? "Debe completar este campo"
                  : false
              }
              value={basic_data.pledge_contact_id}
              input={
                <Input id="grouped-native-select" name="pledge_contact_id" />
              }
            >
              <option value="" />
              {investor_providers.map(investor_provider => (
                <option
                  id={investor_provider.contact_id}
                  value={investor_provider.contact_id}
                >
                  {investor_provider.contact.hansa_code} -{" "}
                  {investor_provider.business_name}
                </option>
              ))}
            </Select>
            {error !== "" && basic_data.pledge_contact_id === "" && (
              <FormHelperText style={{ color: "red" }}>
                Debe completar este campo
              </FormHelperText>
            )}
          </FormControl>
        </React.Fragment>
      ) : (
        ""
      )}

      <TextField
        id="last_km"
        name="last_km"
        label="Últ. KM"
        disabled={disabled}
        error={
          error !== "" && basic_data.last_km === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.last_km === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        placeholder="Ingrese el último km"
        onChange={handleChange}
        value={basic_data.last_km}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="last_km_date"
        name="last_km_date"
        label="Fecha últ. KM"
        disabled={disabled}
        error={
          error !== "" && basic_data.last_km_date !== ""
            ? new Date(basic_data.last_km_date).getTime() >= today.getTime()
              ? "La fecha debe ser menor a la fecha actual"
              : false
            : false
        }
        helperText={
          error !== "" && basic_data.last_km_date !== ""
            ? new Date(basic_data.last_km_date).getTime() >= today.getTime()
              ? "La fecha debe ser menor a la fecha actual"
              : false
            : false
        }
        //helperText= {(error !=='' && basic_data.last_km_date === '' ) ? 'Debe completar este valor' : ''}
        type="date"
        placeholder="Ingrese la fecha del último km"
        onChange={handleChange}
        value={basic_data.last_km_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="chassis"
        name="chassis"
        label="Chasis"
        disabled={disabled}
        error={
          error !== "" && basic_data.chassis === "" && !is_precreated
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.chassis === "" && !is_precreated
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        required={!is_precreated ? true : false}
        placeholder="Ingrese el número de chasis"
        onChange={handleChange}
        value={basic_data.chassis}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="motor_number"
        name="motor_number"
        label="Numero de motor"
        disabled={disabled}
        error={
          error !== "" && basic_data.motor_number === "" && !is_precreated
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && basic_data.motor_number === "" && !is_precreated
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        required={!is_precreated ? true : false}
        placeholder="Ingrese el número de motor"
        onChange={handleChange}
        value={basic_data.motor_number}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      {vehicle_states.length > 0 && (
        <FormControl
          className="mt-3 mr-2"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          name="vehicle_state_id"
        >
          <InputLabel
            htmlFor="grouped-native-select"
            autoWidth="true"
            style={{ minWidth: 200, fontSize: "0.75rem" }}
          >
            Seleccione el estado del vehículo
          </InputLabel>
          <Select
            native
            name="vehicle_state_id"
            inputProps={{
              name: "vehicle_state_id",
              className: "vehicle_state_id"
            }}
            style={{ minWidth: 200, fontSize: "0.75rem" }}
            disabled={state_disabled}
            onChange={handleChange}
            required
            error={
              error !== "" &&
              (basic_data.vehicle_state_id === "1" ||
                basic_data.vehicle_state_id === "")
                ? "Debe completar este campo"
                : false
            }
            value={
              basic_data.vehicle_state_id ? basic_data.vehicle_state_id : ""
            }
            input={<Input id="grouped-native-select" name="vehicle_state_id" />}
          >
            <option value="" />
            {vehicle_states.map(vehicle_state =>
              parseInt(basic_data.is_fleet_owner) ===
              parseInt(vehicle_state.fleet_owner) ? (
                <option id={vehicle_state.id} value={vehicle_state.id}>
                  {vehicle_state.hansa_code} - {vehicle_state.name}
                </option>
              ) : (
                ""
              )
            )}
          </Select>
          {error !== "" &&
            (basic_data.vehicle_state_id === "1" ||
              basic_data.vehicle_state_id === "") && (
              <FormHelperText style={{ color: "red" }}>
                Debe completar este campo
              </FormHelperText>
            )}
        </FormControl>
      )}
      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="condition_type"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Condición del vehículo
        </InputLabel>
        <Select
          native
          name="condition_type"
          inputProps={{
            name: "condition_type",
            className: "condition_type"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          value={basic_data.condition_type}
          input={<Input id="grouped-native-select" name="is_owner" />}
        >
          <option value="" />
          {condition_types.map(condition_type => (
            <option id={condition_type.id} value={condition_type.id}>
              {condition_type.name}
            </option>
          ))}
        </Select>
      </FormControl>
      {/*sap_projects.length > 0 && (
        <FormControl
          className="mt-3 mr-2"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          name="sap_project_id"
        >
          <InputLabel
            htmlFor="grouped-native-select"
            autoWidth="true"
            style={{ minWidth: 200, fontSize: "0.75rem" }}
          >
            Seleccione el proyecto SAP
          </InputLabel>
          <Select
            native
            name="sap_project_id"
            inputProps={{
              name: "sap_project_id",
              className: "sap_project_id"
            }}
            style={{ minWidth: 200, fontSize: "0.75rem" }}
            disabled={state_disabled}
            onChange={handleChange}
            value={basic_data.sap_project_id ? basic_data.sap_project_id : ""}
            input={<Input id="grouped-native-select" name="sap_project_id" />}
          >
            <option value="" />
            {sap_projects.map(sap_project => (
              <option id={sap_project.id} value={sap_project.id}>
                {sap_project.code} - {sap_project.name}
              </option>
            ))}
          </Select>
        </FormControl>
      )*/}
      <Typography variant="h6" className="mt-2">
        Datos InfoAuto
      </Typography>
      <FormControl
        className="mt-1 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="infoauto_price"
      >
        <TextField
          id="infoauto_value"
          name="infoauto_value"
          label="Precio InfoAuto"
          disabled={true}
          type="text"
          value={basic_data.infoauto_price}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
        />
      </FormControl>
      <FormControl
        className="mt-1 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="infoauto_price"
      >
        <TextField
          id="infoauto_value"
          name="infoauto_value"
          label="Fecha Precio InfoAuto"
          disabled={true}
          type="text"
          value={basic_data.infoauto_price_date}
          margin="normal"
          className="mr-2 "
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
        />
      </FormControl>

      {version.infoauto_codia && (
        <InfoAutoDialog version={version} model={variation} />
      )}
    </React.Fragment>
  );
};

export default BasicData;
